import SPListService, { ISPListService } from "./sp-list.service";
import { Utilities, uuid } from '@utils';
import BaseService from "./base.service";

export interface IErrorLoggerService {
    writeError(error: Error, payload?: object): Promise<string>;
}

export interface IError {
    Title: string;
    ErrorMessage: string;
    ErrorStack: string;
    MethodPayload: string;
}

export class ErrorLoggerService extends BaseService implements IErrorLoggerService {

    private _spListService: ISPListService;
    private _listName: string;

    constructor(listName: string) {
        super();

        this._listName = listName;
        this._spListService = new SPListService();
    }

    public async writeError(error: Error, payload?: object): Promise<string> {
        let guid = uuid.v4();

        await this.writeErrorInSPList(error, guid, payload);
        Utilities.writeInConsoleLog(error, payload);

        return Promise.resolve(guid);
    }

    private async writeErrorInSPList(error: Error, guid: string, payload?: object) {
        let errorDto: IError = {
            ErrorMessage: error.message,
            ErrorStack: error.stack,
            MethodPayload: payload ? JSON.stringify(payload) : '',
            Title: guid
        };

        await this._spListService.addItem({
            listName: this._listName,
            item: errorDto
        })
    }

}